export const getPersistedModules = (modules: ReportModule[], moduleDefinitions?: ModuleDefinition[]) =>
  modules.map((module) => {
    const moduleDef = moduleDefinitions?.find((d) => d.id === module.moduleDefinitionId);
    const defaultChartType = moduleDef?.defaultChartType || 'Bar';

    return {
      moduleDefinitionId: module.moduleDefinitionId,
      displayName: module.customName || moduleDef?.name || 'Untitled Module',
      layout: {
        position: { x: module.position.x, y: module.position.y },
        size: { width: module.position.w, height: module.position.h },
      },
      chartType: module.chartType || defaultChartType,
    };
  });
